import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import './BookDetailsPage.css';

const BookDetailsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [book, setBook] = useState(null);
  const [relatedBooks, setRelatedBooks] = useState([]);
  const [activeTab, setActiveTab] = useState('description');

  useEffect(() => {
    // في التطبيق الحقيقي سيأتي من API
    const sampleBook = {
      id: parseInt(id),
      title: `كتاب رقم ${id}`,
      author: `المؤلف ${Math.floor(Math.random() * 20) + 1}`,
      price: Math.floor(Math.random() * 100) + 20,
      category: ['شعر', 'قصص', 'تطوير ذات', 'أدب', 'رواية'][Math.floor(Math.random() * 5)],
      description: `هذا وصف مفصل للكتاب رقم ${id}. يحتوي هذا الكتاب على محتوى غني ومفيد يساعد القارئ على فهم الموضوع بشكل عميق. تم كتابة هذا الكتاب بأسلوب سهل ومفهوم ليناسب جميع الأعمار والمستويات التعليمية.`,
      fullDescription: `وصف شامل ومفصل للكتاب رقم ${id}. هذا الكتاب يعتبر من الأعمال المميزة في مجاله، حيث يقدم نظرة عميقة وشاملة حول الموضوع المطروح. يتميز الكتاب بأسلوب الكاتب الرائع والذي يجمع بين البساطة والعمق في آن واحد.

يحتوي الكتاب على عدة فصول مترابطة تبدأ من المفاهيم الأساسية وتتدرج نحو المواضيع الأكثر تعقيداً. كما يتضمن أمثلة عملية وتطبيقات واقعية تساعد القارئ على فهم المحتوى بشكل أفضل.

هذا الكتاب مناسب للمبتدئين والمتقدمين على حد سواء، ويمكن الاستفادة منه في المجالات الأكاديمية والعملية.`,
      publishDate: new Date(2024, Math.floor(Math.random() * 12), Math.floor(Math.random() * 28) + 1),
      rating: (Math.random() * 2 + 3).toFixed(1),
      pages: Math.floor(Math.random() * 300) + 100,
      language: 'العربية',
      isbn: `978-977-${Math.floor(Math.random() * 1000)}-${Math.floor(Math.random() * 100)}`,
      publisher: 'بصمة آثر للنشر',
      edition: '1',
      format: 'ورقي وإلكتروني',
      image: '/api/placeholder/300/400',
      authorBio: `سيرة ذاتية مختصرة للمؤلف. كاتب وأديب مصري معاصر، له العديد من الأعمال المنشورة في مختلف المجالات الأدبية. حاصل على عدة جوائز أدبية محلية وعربية.`,
      tableOfContents: [
        'المقدمة',
        'الفصل الأول: المفاهيم الأساسية',
        'الفصل الثاني: التطبيقات العملية',
        'الفصل الثالث: دراسات الحالة',
        'الفصل الرابع: النتائج والتوصيات',
        'الخاتمة',
        'المراجع'
      ],
      reviews: [
        { name: 'أحمد محمد', rating: 5, comment: 'كتاب رائع ومفيد جداً، أنصح بقراءته' },
        { name: 'فاطمة علي', rating: 4, comment: 'محتوى جيد وأسلوب سهل' },
        { name: 'محمد حسن', rating: 5, comment: 'من أفضل الكتب التي قرأتها في هذا المجال' }
      ]
    };

    setBook(sampleBook);

    // كتب مشابهة
    const related = Array.from({ length: 4 }, (_, index) => ({
      id: Math.floor(Math.random() * 100) + 1,
      title: `كتاب مشابه ${index + 1}`,
      author: `مؤلف ${index + 1}`,
      price: `${Math.floor(Math.random() * 80) + 30} جنيه`,
      rating: (Math.random() * 2 + 3).toFixed(1)
    }));
    setRelatedBooks(related);
  }, [id]);

  if (!book) {
    return (
      <div className="loading">
        <div className="container">
          <p>جاري تحميل تفاصيل الكتاب...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="book-details-page">
      <div className="container">
        {/* Breadcrumb */}
        <nav className="breadcrumb">
          <Link to="/">الرئيسية</Link>
          <span>/</span>
          <Link to="/books">الكتب</Link>
          <span>/</span>
          <span>{book.title}</span>
        </nav>

        {/* Book Details */}
        <div className="book-details">
          <div className="book-image-section">
            <div className="book-cover">
              <i className="fas fa-book"></i>
            </div>
            <div className="book-rating-large">
              <div className="stars">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className={`fas fa-star ${i < Math.floor(book.rating) ? 'filled' : ''}`}></i>
                ))}
              </div>
              <span className="rating-number">{book.rating} من 5</span>
              <span className="reviews-count">({book.reviews.length} تقييم)</span>
            </div>
          </div>

          <div className="book-info-section">
            <h1 className="book-title">{book.title}</h1>
            <p className="book-author">بقلم: <Link to={`/authors/${book.author}`}>{book.author}</Link></p>
            <span className="book-category">{book.category}</span>
            
            <div className="book-meta-info">
              <div className="meta-item">
                <strong>عدد الصفحات:</strong> {book.pages} صفحة
              </div>
              <div className="meta-item">
                <strong>اللغة:</strong> {book.language}
              </div>
              <div className="meta-item">
                <strong>تاريخ النشر:</strong> {book.publishDate.toLocaleDateString('ar-EG')}
              </div>
              <div className="meta-item">
                <strong>الناشر:</strong> {book.publisher}
              </div>
              <div className="meta-item">
                <strong>الطبعة:</strong> {book.edition}
              </div>
              <div className="meta-item">
                <strong>التنسيق:</strong> {book.format}
              </div>
              <div className="meta-item">
                <strong>ISBN:</strong> {book.isbn}
              </div>
            </div>

            <div className="book-price-section">
              <span className="current-price">{book.price} جنيه</span>
              <div className="book-actions">
                <button 
                  className="btn btn-primary btn-large"
                  onClick={() => addToCart(book)}
                >
                  <i className="fas fa-shopping-cart"></i>
                  أضف للسلة
                </button>
                <button className="btn btn-secondary">
                  <i className="fas fa-heart"></i>
                  المفضلة
                </button>
                <button className="btn btn-secondary">
                  <i className="fas fa-share"></i>
                  مشاركة
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Tabs Section */}
        <div className="book-tabs">
          <div className="tab-headers">
            <button 
              className={`tab-header ${activeTab === 'description' ? 'active' : ''}`}
              onClick={() => setActiveTab('description')}
            >
              الوصف
            </button>
            <button 
              className={`tab-header ${activeTab === 'contents' ? 'active' : ''}`}
              onClick={() => setActiveTab('contents')}
            >
              المحتويات
            </button>
            <button 
              className={`tab-header ${activeTab === 'author' ? 'active' : ''}`}
              onClick={() => setActiveTab('author')}
            >
              عن المؤلف
            </button>
            <button 
              className={`tab-header ${activeTab === 'reviews' ? 'active' : ''}`}
              onClick={() => setActiveTab('reviews')}
            >
              التقييمات
            </button>
          </div>

          <div className="tab-content">
            {activeTab === 'description' && (
              <div className="description-tab">
                <h3>وصف الكتاب</h3>
                <p>{book.fullDescription}</p>
              </div>
            )}

            {activeTab === 'contents' && (
              <div className="contents-tab">
                <h3>فهرس المحتويات</h3>
                <ul className="table-of-contents">
                  {book.tableOfContents.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            )}

            {activeTab === 'author' && (
              <div className="author-tab">
                <h3>عن المؤلف</h3>
                <p>{book.authorBio}</p>
              </div>
            )}

            {activeTab === 'reviews' && (
              <div className="reviews-tab">
                <h3>تقييمات القراء</h3>
                <div className="reviews-list">
                  {book.reviews.map((review, index) => (
                    <div key={index} className="review-item">
                      <div className="review-header">
                        <strong>{review.name}</strong>
                        <div className="review-stars">
                          {[...Array(5)].map((_, i) => (
                            <i key={i} className={`fas fa-star ${i < review.rating ? 'filled' : ''}`}></i>
                          ))}
                        </div>
                      </div>
                      <p>{review.comment}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Related Books */}
        <div className="related-books">
          <h3>كتب مشابهة</h3>
          <div className="related-books-grid">
            {relatedBooks.map((relatedBook) => (
              <div key={relatedBook.id} className="related-book-card">
                <div className="related-book-image">
                  <i className="fas fa-book"></i>
                </div>
                <div className="related-book-info">
                  <h4>{relatedBook.title}</h4>
                  <p>{relatedBook.author}</p>
                  <div className="related-book-footer">
                    <span className="price">{relatedBook.price}</span>
                    <Link to={`/books/${relatedBook.id}`} className="btn btn-small">
                      عرض
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookDetailsPage;
